/* eslint-disable no-console */
import { register } from 'register-service-worker';

// Create a custom event emitter for SW events
export const SwEventBus = new EventTarget();

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      SwEventBus.dispatchEvent(new CustomEvent('sw-ready'));
    },
    registered (registration) {
      SwEventBus.dispatchEvent(new CustomEvent('sw-registered', { detail: registration }));
    },
    cached () {
      SwEventBus.dispatchEvent(new CustomEvent('sw-cached'));
    },
    updatefound () {
      SwEventBus.dispatchEvent(new CustomEvent('sw-updatefound'));
    },
    updated (registration) {
      SwEventBus.dispatchEvent(new CustomEvent('sw-updated', { detail: registration }));
    },
    offline () {
      SwEventBus.dispatchEvent(new CustomEvent('sw-offline'));
    },
    error (error) {
      SwEventBus.dispatchEvent(new CustomEvent('sw-error', { detail: error }));
    }
  });
}
